import '../styles/AboutUsPage.scss';
import Footer from '../components/Footer';
import ContactForm from '../components/ContactForm';  // Assuming this is a component, not an image
import { useModal } from '../components/ModalContext';

const RIghtArrowBgWhite = `${process.env.REACT_APP_S3_URL}RIghtArrowBgWhite.svg`;
const Mouse = `${process.env.REACT_APP_S3_URL}Computer%20Mouse.svg`; // Encoding space as %20
const VisionIcon = `${process.env.REACT_APP_S3_URL}vision.svg`;
const MissionIcon = `${process.env.REACT_APP_S3_URL}mission.svg`;
const Amitabh = `${process.env.REACT_APP_S3_URL}Amitabh+Kanekar.png`;
const Satyajit = `${process.env.REACT_APP_S3_URL}Satyajit+Kanekar.png`;
const Carlin = `${process.env.REACT_APP_S3_URL}Carlin+Crasto.png`;
const Hitesh = `${process.env.REACT_APP_S3_URL}Hitesh+Arora.png`;
const Rinkee = `${process.env.REACT_APP_S3_URL}Rinkee+Pillai.png`;
const rightArrowSlant = `${process.env.REACT_APP_S3_URL}rightSlantblack.svg`;
const LinkedIn = `${process.env.REACT_APP_S3_URL}LinkedIn-Blue.png`;
function AboutUsPage() {
  const { openModal } = useModal();
  return (
    <div className="about-us-page">
      <section className="hero-section">
        <div className="hero-text-box">
          <h1>
          Trusted Payments Partner
          <br></br>For Nearly&nbsp;<span style={{
                    background: 'linear-gradient(81.88deg, #E51A4B 0%, #E36F8A 107.04%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text', // For Firefox
                    color: 'transparent',
                  }}>Two Decades</span>
          </h1>
        </div>
        <button className="cta-button-schedule" onClick={openModal} style={{ backgroundColor: '#E5194B' }}>
            <div className='align-proper' >
                <span className='button-name' style={{ color: '#FFF' }}>
                &nbsp;&nbsp;Get in touch &nbsp;&nbsp;
                </span>
                <img src={RIghtArrowBgWhite} alt='' />
            </div>
        </button>
        <div className="scroll-indicator">
          <img src={Mouse} alt="Mouse Icon" className="mouse-icon" />
          <p style={{ color: '#8E757B'}}>Scroll Down</p>
        </div>
      </section>

      <section className="company-info">
        <div style={{ display: 'flex', justifyContent:'center' }}>
          <div className='vertical-gradient-border'></div>
        </div>
        <div className="company-description">
          <p style={{ marginTop: 0 }}>
            <span style={{
                    background: 'linear-gradient(81.88deg, #E51A4B 0%, #E36F8A 107.04%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text', // For Firefox
                    color: 'transparent',
                  }}>86400</span> has established itself as a trusted technical service provider for payments infrastructure. We
            power digital transactions for Banks, Fintechs, and NBFCs with a robust suite of offerings, including NPCI
            switches, and our flagship API Banking platform- TransXT.
          </p>
        </div>
      </section>

      <section className="vision-mission" >
        <div className='vision-container'>
          <div className="vision">
            <div
              style={{
                display:'flex',
                flexDirection:'row',
                justifyContent:'flex-start',
                alignItems:'center',
                gap:10
              }}
            >
              <img src={VisionIcon} alt="Vision Icon" width="30px" height="30px"/>
              <h3>Vision</h3>
            </div>
            <div>
              <p>
                To Empower Financial And Business Institutions With Intelligent Payment Enablement And Data Driven Insights;
                Building One Of the Largest Platforms That Drives Sustainable Growth, Innovation And Trust In the Digital Economy.
              </p>
            </div>
          </div>
          <div className="mission">
            <div style={{
              display:'flex',
              flexDirection:'row',
              justifyContent:'flex-start',
              alignItems:'center',
              gap:16
            }}>
              <img src={MissionIcon} alt="Mission Icon" width="30px" height="30px"/>
              <h3>Mission</h3>
            </div>
            <div>
              <p>
                To Power Seamless Digital Payments at Scale, Enabling Billions of Secure Transactions Each Year
                And Shaping The Future Of Financial Access.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="core-team">
        <h2>
          Meet The <span style={{
                    background: 'linear-gradient(81.88deg, #E51A4B 0%, #E36F8A 107.04%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text', // For Firefox
                    color: 'transparent',
                  }}>Core</span> Team
        </h2>
        
        <div className="team-members">
          <div className="team-member" onClick={() => {window.open('https://www.linkedin.com/in/akanekar/', '_blank')}}>
            <div  className='team-member-image' >
              <img src={Amitabh} alt="Amitabh Kanekar" className='teammate-image'/>
              <div className='hover-link'>
                <img src={rightArrowSlant} alt=''/>
              </div>
            </div>
            <div className='member-info-container'>
              <div className="member-info">
                <h3 style={{ marginTop: '0px'}}>Amitabh Kanekar</h3>
                <p>Co-Founder & COO</p>
              </div>
              <div className='linkedin-hover-link'>
                <img style={{ width: 48, height: 48, borderRadius:0 }} src={LinkedIn} alt='' />
              </div>
            </div>
          </div>
          <div className="team-member" onClick={() => {window.open('https://www.linkedin.com/in/satyajitkanekar/', '_blank')}}>
            <div  className='team-member-image' >
              <img  src={Satyajit} alt="Satyajit Kanekar" className='teammate-image'/>
              <div className='hover-link'>
                <img src={rightArrowSlant} alt='' />
              </div>
            </div>
            <div className='member-info-container'>
              <div className="member-info">
                <h3 style={{ marginTop: '0px'}}>Satyajit Kanekar</h3>
                <p>Co-Founder & CEO</p>
              </div>
              <div className='linkedin-hover-link'>
                <img style={{ width: 48, height: 48, borderRadius:0 }} src={LinkedIn} alt='' />
              </div>
            </div>
          </div>
          <div className="team-member" onClick={() => {window.open('https://www.linkedin.com/in/carlincrasto/', '_blank')}}>
          <div  className='team-member-image' >
              <img   src={Carlin} alt="Carlin Castro" className='teammate-image'/>
              <div className='hover-link'>
                <img src={rightArrowSlant} alt='' />
              </div>
            </div>
            <div className='member-info-container'>
              <div className="member-info">
                <h3 style={{ marginTop: '0px'}}>Carlin Crasto</h3>
                <p>Chief Technology Officer</p>
              </div>
              <div className='linkedin-hover-link'>
                <img style={{ width: 48, height: 48, borderRadius:0 }} src={LinkedIn} alt='' />
              </div>
            </div>
          </div>
          <div className="team-member" onClick={() => {window.open('https://www.linkedin.com/in/hitesh-arora-50870a6/', '_blank')}}>
          <div  className='team-member-image' >
              <img src={Hitesh} alt="Hitesh Arora" className='teammate-image'/>
              <div className='hover-link'>
                <img src={rightArrowSlant} alt='' />
              </div>
            </div>
            <div className='member-info-container'>  
              <div className="member-info">
                <h3 style={{ marginTop: '0px'}}>Hitesh Arora</h3>
                <p>Chief Business Officer</p>
              </div>
              <div className='linkedin-hover-link'>
                <img style={{ width: 48, height: 48, borderRadius:0 }} src={LinkedIn} alt='' />
              </div>
            </div>
          </div>
          <div className="team-member" onClick={() => {window.open('https://www.linkedin.com/in/rinkeepillai/', '_blank')}}>
            <div  className='team-member-image' >
              <img src={Rinkee} alt="Rinkee Pillai" className='teammate-image'/>
              <div className='hover-link'>
                <img src={rightArrowSlant} alt='' />
              </div>
            </div>
            <div className='member-info-container'>
              <div className="member-info">
                <h3 style={{ marginTop: '0px'}}>Rinkee Pillai</h3>
                <p>Head Client Experience</p>
              </div>
              <div className='linkedin-hover-link'>
                <img style={{ width: 48, height: 48, borderRadius:0 }} src={LinkedIn} alt='' />
              </div>
            </div>
          </div>
        </div>
      </section>
      <ContactForm />
      <Footer />
    </div>
  );
}

export default AboutUsPage;
